/* ============================================================
   Division 7 Supply — AprilAire Wi-Fi Upgrade Panel (70000238)
   Resource Center. Scoped landing-page behavior (all hooks under
   the .awp root).
   - Scroll reveal (elements visible by default; JS hides only
     below-fold ones, then reveals by scroll position — so if JS
     fails, everything stays visible).
   - FAQ accordion (one open at a time; none open by default).
   - Sticky buy bar (shows after 640px scroll; bottom bar on mobile).
   - Add-to-cart (qty 1) with states + out-of-stock/422 handling.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.awpInit === '1') return;
    root.dataset.awpInit = '1';
    initReveal(root);
    initFaq(root);
    initSticky(root);
    initCart(root);
  }

  /* ---------------- scroll reveal ---------------- */
  function initReveal(root) {
    var seen = new WeakSet();
    var threshold = function () { return window.innerHeight - 40; };
    function scan() {
      root.querySelectorAll('[data-reveal]').forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        if (el.getBoundingClientRect().top > threshold()) el.classList.add('rv-pre');
      });
    }
    function check() {
      root.querySelectorAll('[data-reveal].rv-pre').forEach(function (el) {
        if (el.getBoundingClientRect().top < threshold()) el.classList.remove('rv-pre');
      });
    }
    scan(); check();
    var onScroll = function () { check(); toggleSticky(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { scan(); check(); });
    // Safety net for content that shifts in (fonts/images) without a scroll event.
    root._awpRevealIv = setInterval(check, 700);
    setTimeout(function () { scan(); check(); }, 300);
  }

  /* ---------------- sticky buy bar ---------------- */
  var stickyEl = null;
  function initSticky(root) { stickyEl = root.querySelector('.awp-sticky'); toggleSticky(); }
  function toggleSticky() {
    if (!stickyEl) return;
    stickyEl.classList.toggle('is-visible', window.scrollY > 640);
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq(root) {
    var buttons = root.querySelectorAll('.awp-faq__q');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        buttons.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var body = b.parentElement.querySelector('.awp-faq__body');
          if (body) body.setAttribute('data-open', '0');
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          var body = btn.parentElement.querySelector('.awp-faq__body');
          if (body) body.setAttribute('data-open', '1');
        }
      });
    });
  }

  /* ---------------- add to cart (qty 1) ---------------- */
  function initCart(root) {
    var OOS_MSG = "Out of stock — call +1 (678) 541-0303 and we'll get you sorted.";
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-awp-add]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading') || btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
      var label = btn.querySelector('[data-awp-label]');
      var group = btn.closest('[data-awp-cta]');
      var msg = group ? group.querySelector('[data-awp-stock]') : null;
      var original = label ? label.textContent : '';
      if (!variantId) return;
      if (msg) msg.hidden = true;

      btn.classList.add('is-loading');
      if (label) label.textContent = 'Adding…';

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (data) {
              var err = new Error('add-failed'); err.status = res.status; err.data = data; throw err;
            });
          }
          return res.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          if (label) label.textContent = 'Added to cart';
          refreshCart();
          setTimeout(function () { if (label) label.textContent = original; }, 3000);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          if (label) label.textContent = original;
          if (msg) {
            var d = err && err.data && err.data.description;
            msg.textContent = (err && err.status === 422) ? OOS_MSG : (d || OOS_MSG);
            msg.hidden = false;
          }
        });
    });
  }

  function refreshCart() {
    if (document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    } else {
      var r = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
      window.location = r + 'cart';
    }
  }

  /* ---------------- boot ---------------- */
  function boot() { document.querySelectorAll('.awp').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.awp');
    if (el) init(el);
  });
})();
